/* Fransk katalog for locale-settings-integrations-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'set.integr.wooImported': '{orders} événements de vente et de remboursement importés',
  'set.integr.wooLastSync': 'Dernière synchronisation {date}',
  'set.integr.wooDisconnectTitle': 'Déconnecter WooCommerce',
  'set.integr.wooDisconnectHelp': 'Plumme cessera de récupérer les nouvelles commandes et les retours. Les événements déjà importés et les clôtures journalières comptabilisées sont conservés avec leur piste d\'audit.',
  'set.integr.wooDisconnectedToast': 'WooCommerce a été déconnecté.',
  'set.integr.wooDisconnectError': 'Impossible de déconnecter WooCommerce.',
  'set.integr.wooUnavailable': 'L\'intégration WooCommerce n\'est pas disponible dans cette version.',
});
